import ProductsApi from "@/scripts/api/products.api";

import {
  getIntro,
  getElReviewItem, getElList
} from "@/scripts/components/review-list/helpers/renderReviewItem";
import {ProductResponseDTO, ProductReviewResponseDTO} from "@shared/DTO";

export class ReviewListController {

  constructor(
    private rootEl: HTMLElement,
    private props: {productIdWp?: string; productId?: string} = {}
  ) {}

  private _productApiService = ProductsApi;

  get productId() {
    return this.props?.productId;
  }

  set productId(v: string | undefined) {
    this.props.productId = v;
  }

  mount() {
    if(!this.productId && !this.props?.productIdWp) return;
    this.reload(); // primo load
  }

  unmount() { }

  updateProps(next: Partial<{productIdWp?: string; productId?: string}>) {
    const prev = this.props;
    this.props = { ...this.props, ...next };
    if (next.productId && next.productId !== prev.productId) {
      this.reload();
    }
  }

  async reload() {
    this.rootEl.replaceChildren(); // svuota tutto

    // IF qui sotto: durante la fase di transizione, per...
    // ...permettere di ricercare prodotto tramite id WP

    let product: ProductResponseDTO;
    let reviews: ProductReviewResponseDTO[];
    if(this.productId) {
      [product, reviews] = await Promise.all([
        this.fetchProduct(this.productId),
        this.fetchReviews(this.productId)
      ]);
    } else  {
      product = await this.fetchProduct(`wp/${this.props.productIdWp}`);
      this.productId = product?._id;
      if(product) {
        reviews = await this.fetchReviews(product._id);
      }
    }

    if(!product) return;
    const { heading, paragraph } = getIntro(product, reviews);
    this.rootEl.append(heading, paragraph);
    if(!reviews?.length) return;

    const list = getElList();
    const listFragment = document.createDocumentFragment();
    reviews.forEach((review) => listFragment.append(getElReviewItem(review)));
    list.replaceChildren(listFragment);
    this.rootEl.append(list);
  }

  private async fetchProduct(productId: string) {
    try {
    if (!productId) {
      throw new Error("Product ID is required to fetch product details.");
    }
      return await this._productApiService.getProduct(productId);
    } catch (error) {
      console.error("Failed to fetch product:", error);
      return null;
    }
  }

  private async fetchReviews(productId: string) {
    try {
      return await this._productApiService.getReviews(productId);
    } catch (error) {
      console.error("Failed to fetch reviews:", error);
      return [];
    }
  }

}